import { render } from "./YellowLetters.vue?vue&type=template&id=424a1b52&scoped=true&ts=true"
import script from "./YellowLetters.vue?vue&type=script&lang=ts"
export * from "./YellowLetters.vue?vue&type=script&lang=ts"

import "./YellowLetters.vue?vue&type=style&index=0&id=424a1b52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424a1b52"]])

export default __exports__